import './Loader.css';

export default function Loader() {
  return (
    <div className="loader">
      <div className="loader-inner">
        <div className="loader-block"></div>
        <div className="loader-block"></div>
        <div className="loader-block"></div>
        <div className="loader-block"></div>
        <div className="loader-block"></div>
      </div>
    </div>
  );
}
